import { useState } from 'react'

import classNames from 'classnames'
import { ContentPageImage } from 'globalTypes'
import { useResizeDetector } from 'react-resize-detector'

import isFinite from 'lodash/isFinite'

interface Props {
  content: ContentPageImage
}

const SingleImage = ({ content }: Props) => {
  const coverDimensions = content?.coverDimensions

  const [loaded, setLoaded] = useState<boolean>(false)
  const { width, ref } = useResizeDetector()

  const finalHeight =
    Boolean(coverDimensions?.height) && Boolean(coverDimensions?.width)
      ? (width / coverDimensions?.width) * coverDimensions?.height
      : undefined

  const hasFinalHeight = isFinite(finalHeight) && !loaded

  return (
    <div ref={ref}>
      <img
        className={classNames('w-full h-full rounded-xl overflow-hidden', {
          'bg-gray-100': hasFinalHeight,
          'animate-pulse': hasFinalHeight && !loaded,
        })}
        alt={content.title}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        src={content.url}
        style={hasFinalHeight ? { height: finalHeight } : undefined}
      />
    </div>
  )
}

export default SingleImage
